import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';



export class ChapterHundredTwelve extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">

        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>

          <TextHolder text="We are a catalyst. A global movement supporting the next level of groundbreaking founders."/>
          <TextHolder text="The core of Slush Singapore is building a worldwide startup community for change-makers, by change-makers. Slush has always been about its spirit—an explosion of energy and drive."/>
          <TextHolder text="Initiated in Helsinki, Finland, 10 years ago, Slush has always been a ground-up initiative, powered by volunteers and a passion for change. Throughout the years, the not-for-profit initiative grew into a world-renown tech startup event held in Helsinki, later spreading to Tokyo, Shanghai and Singapore. But the mission of Slush has remained the same: to help entrepreneurs succeed."/>
          <TextHolder text="Slush Singapore was first organized in 2016 with the help of an enthusiastic community of startups, investors and other ecosystem players. Today, Slush Singapore sees some 3,000 attendees from over 70 countries gather in the heart of SEA every September to solve some of the biggest problems in technology and entrepreneurship. They are startups, investors, corporates and media. They are the change-makers."/>
          <TextHolder text="Besides being a platform for startups, Slush Singapore is creating a pool of talent in the region. We are incredibly proud of the hundreds of volunteers we get to work with every year. We see their talent, drive and motivation to change the world. We want to continue supporting them beyond Slush Singapore and to offer companies in SEA a chance to work with some of the brightest minds of the future."/>
          <TextHolder text="Finally, Slush Singapore is here for SEA. Being one of the most international events in the region, we are a bridge between the region and the rest of the world, connecting change-makers from all over the globe. We are thrilled to work with fantastic partners across SEA—from technology giants to small startups—to help the next generation of world-conquering entrepreneurs forward!"/>
          <TextHolder text="" />


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/112.js